import { formatDistance } from "@lib/utils";
import { useLanguage } from "@lib/utils/hooks/useLanguage";
import { PathResponse } from "@repo/shared-types";
import { useTranslations } from "next-intl";
import { Popup as MapboxPopup } from "react-map-gl";

interface IDistanceToPointPopup {
  latitude: number;
  longitude: number;
  path: PathResponse;
  distances: { start: number; end: number };
}

export function DistanceToPointPopup({
  latitude,
  longitude,
  path,
  distances,
}: IDistanceToPointPopup) {
  const language = useLanguage();
  const t = useTranslations("Map");

  return (
    <MapboxPopup
      className="distance-to-point-popup"
      longitude={longitude}
      latitude={latitude}
      anchor="top-right"
      offset={10}
      closeOnClick={false}
    >
      <div className="grid-cols-[minmax(0, 1fr)_auto] grid grid-rows-2 justify-between gap-x-8 gap-y-1 p-3 text-xs">
        <div className="text-secondary-light row-start-1">{path.from}</div>
        <div className="row-start-1 justify-self-end font-bold text-primary-dark">{`${formatDistance(distances.start, language)} ${t("LengthIndicator")}`}</div>
        <div className="text-secondary-light row-start-2">{path.to}</div>
        <div className="row-start-2 justify-self-end font-bold text-primary-dark">{`${formatDistance(distances.end, language)} ${t("LengthIndicator")}`}</div>
      </div>
    </MapboxPopup>
  );
}
